import React from 'react';
import './LoadingOverlay.scss';

const LoadingOverlay = ({ visible, text = 'Đang lưu module' }) => {
  if (!visible) return null;

  return (
    <div className="loading-overlay">
      <div className="spinner">
        <div className="spinner-inner"></div>
      </div>
      {text && (
        <div className="loading-text">
          {text}

          <span>...</span>
        </div>
      )}
    </div>
  );
};

export default LoadingOverlay;
